@if (
    {
        selection: selection$ | async,
        streamId: stateStream$ | async,
        streams: streams$ | async,
    };
    as data
) {
    <div class="flex row">
        <div class="flex row align-items-center flex-45">
            <button mat-icon-button aria-label="Clear Selection" (click)="clearSelection()">
                <mat-icon>close</mat-icon>
            </button>
            <span>{{ data.selection?.length }} selected</span>
        </div>
        @if (data.selection?.length) {
            <div class="flex align-end justify-center">
                <button
                    mat-icon-button
                    aria-label="Create Group"
                    matTooltip="Group selected assets together"
                    (click)="groupSelection(data.selection, data.streamId)"
                >
                    <mat-icon>collections</mat-icon>
                </button>
                <button
                    mat-icon-button
                    aria-label="Download"
                    matTooltip="Download selected assets"
                    (click)="download(data.selection)"
                >
                    <mat-icon>download</mat-icon>
                </button>
                <button
                    mat-icon-button
                    aria-label="Share"
                    matTooltip="Create a link to selected assets"
                    (click)="getLink(data.selection, data.streamId)"
                >
                    <mat-icon>share</mat-icon>
                </button>
                <button
                    mat-icon-button
                    #menuTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="moreMenu"
                >
                    <mat-icon>more_vertical</mat-icon>
                </button>
            </div>
        }
    </div>
    <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="openEditTags(data.selection)">
            <mat-icon>label</mat-icon>
            <span>Edit Tags</span>
        </button>
        <frog-stream-move-menu
            [copy]="false"
            [assets]="data.selection"
            [streamId]="data.streamId"
            (select)="clearSelection()"
        ></frog-stream-move-menu>
        <frog-stream-move-menu
            [copy]="true"
            [assets]="data.selection"
            (select)="clearSelection()"
        ></frog-stream-move-menu>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="delete(data.selection)">
            <mat-icon>delete</mat-icon>
            <span>Remove/Delete</span>
        </button>
    </mat-menu>
}
